import React, { useEffect } from "react";
import { Tab, Nav, Row, Col } from "react-bootstrap";
import TeamList from "../FnComponents/TeamList";
import Scorecard from "../FnComponents/scorecard";
import ContestContainer from "../FnComponents/ContestContainer";
import { useNavigate, useParams } from "react-router-dom";
import CreateTeam from "./CreateButton";
import actions from "../../redux/actions";
import { getPlayersByMatch, saveMyTeam } from "../../utils/playerSession";

const FnMatchTabs = ({matchDetails}) => {
  const navigate = useNavigate();
  const { matchId } = useParams();

  const [teams, setTeams] = React.useState([]);
  const [players, setPlayers] = React.useState([]);

  useEffect(() => {
    fetchTeams();
  }, [matchId]);

  const fetchTeams = async () => {
    try {
      const { data, status } = await actions.getTeamsAll(matchId);

      if (status !== 200) {
        throw new Error("Failed to fetch teams");
      }
      console.log("Teams Data:", data);

      saveMyTeam(data || []);
      setTeams(data || []);

      // Fetch Players Properly
      const matchPlayers = await getPlayersByMatch(matchId);
      console.log("Match Players:", matchPlayers);
      setPlayers(matchPlayers || []);

    } catch (error) {
      console.error("Error fetching teams:", error.message);
      setTeams([]);
    }
  };

  return (
    <Tab.Container defaultActiveKey="tab1" id="tab-layout">
      <Nav variant="tabs" className="custom-nav-tabs mx-0 mb-0">
        <Nav.Item>
          <Nav.Link eventKey="tab1" className="custom-nav-link2 cricket">
            Contests
          </Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link eventKey="tab2" className="custom-nav-link2">
            My Team ({teams.length})
          </Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link eventKey="tab3" className="custom-nav-link3">
            Scorecard
          </Nav.Link>
        </Nav.Item>
      </Nav>

      <Row className="justify-content-center">
        <Col>
          <Tab.Content>
            <Tab.Pane eventKey="tab1">
              <div className="tab-content custom-tab-content">
                <ContestContainer myTeams={teams} matchId={matchId} />
              </div>
            </Tab.Pane>

            <Tab.Pane eventKey="tab2">
              <div className="tab-content custom-tab-content">
                <CreateTeam onClick={() => navigate(`/createteam/${matchId}`)} />
                <TeamList myTeams={teams} players={players} matchDetails={matchDetails} />
              </div>
            </Tab.Pane>

            <Tab.Pane eventKey="tab3">
              <div className="tab-content custom-tab-content">
                <Scorecard />
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
};

export default FnMatchTabs;
